import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DocumentsComponent } from './components/documents/documents-list.component';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './services/in-memory-data.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { SearchComponent } from './components/search/search.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DocumentComponent } from './components/documents/document.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NoDocsResultComponent } from './components/documents/no-docs-result.component';
import { SearchErrorComponent } from './components/search-error/search-error.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ExportDocumentComponent } from './components/export-document/export-document.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { FooterComponent } from './components/footer/footer.component';
import { DocumentosCeaComponent } from './components/documentos-cea/documentos-cea.component';
import { NavbarCeaComponent } from './components/navbar-cea/navbar-cea.component';
import { FooterCeaComponent } from './components/footer-cea/footer-cea.component';

export function createTranslateLoader(http: HttpClient){
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DocumentsComponent,
    SearchComponent,
    NavbarComponent,
    NavbarCeaComponent,
    DocumentComponent,
    NoDocsResultComponent,
    SearchErrorComponent,
    LoginComponent,
    MainComponent,
    NotFoundComponent,
    SpinnerComponent,
    ExportDocumentComponent,
    DocumentosComponent,
    FooterComponent,
    FooterCeaComponent,
    DocumentosCeaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    // HttpClientInMemoryWebApiModule.forRoot(
    //   InMemoryDataService, { dataEncapsulation: false }
    // ),
    HttpClientModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    FontAwesomeModule,
    NgbModule,
    CollapseModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
